import type { Event } from "@circle-react/types";
import { ScheduledEmailSection } from "./ScheduledEmailSection";
import { ScheduledEmailProvider } from "./useScheduledEmailContext";

export const Email = ({ event }: { event: Event }) => (
  <ScheduledEmailProvider event={event}>
    <ScheduledEmailSection event={event} />
  </ScheduledEmailProvider>
);
